import React from "react";
import CharityCard from "../charity/CharityCard";

const UpperCarousel = () => {
  return (
    <div className="bg-gray-100">
      <div className="flex flex-col md:flex-row">
        <div
          className="p-4 md:p-16 ml-4 md:ml-16 text-2xl md:text-4xl text-[#0077B6]"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Funding on multiple causes
        </div>
        <div className="p-4 md:pt-16 w-full md:w-[900px]">
          With our innovative platform, you have the power to make a difference
          in multiple lives and causes. Explore a world of opportunities to
          donate and support the causes closest to your heart, all in one
          convenient place. Join us in spreading love, kindness, and hope
          through your donations. Together, we can change the world, one cause
          at a time.
        </div>
      </div>
      <CharityCard />
    </div>
  );
};

export default UpperCarousel;
